import { type ReactNode } from 'react'
import { type WithPermissionEntityId } from '@terros/common'
import { usePermissions } from '@front/model'
import { TDrawer, type TDrawerProps } from '../terros'
import { ButtonRefresh } from '../buttons'
import { EntityPermissions } from './EntityPermissions'

type Props = WithPermissionEntityId & Pick<TDrawerProps, 'onClose' | 'opened' | 'title'>

export const PermissionDrawer = ({ entityId, ...drawerProps }: Props): ReactNode => {
  const { data: permissionList, refetch, isFetching } = usePermissions(entityId)

  return (
    <TDrawer size='xl' {...drawerProps} headerActions={<ButtonRefresh isFetching={isFetching} refetch={refetch} />}>
      {permissionList && <EntityPermissions entityId={entityId} permissionList={permissionList} />}
    </TDrawer>
  )
}
